import { connect } from 'react-redux';
import ResetPasswordView from './ResetPasswordView';
import { resetPassword, resetPasswordFormLoaded } from '../../actions';

const mapStateToProps = (state) => ({
  ...state.resetPassword,
  isLoading: state.request.RESET_PASSWORD_REQUEST,
});

export default connect(mapStateToProps, {
  resetPassword,
  resetPasswordFormLoaded,
})(ResetPasswordView);
